import { useEffect } from 'react';
import useSWR from 'swr';
import { API_GET_USER } from '../api/configurationScreenServices';
import analytics from '../utils/analytics';
import { setUserContext } from '../utils/monitoring';

const fetcher = async () => {
  const res = await API_GET_USER();
  if (res?.status !== 200) throw new Error('user fetch failed');
  setUserContext({
    userId: res.data?.id,
    orgCode: res.data?.orgCode
  });
  return res.data;
};

export const currentUserKey = 'currentUser';

export function useCurrentUser() {
  const result = useSWR(currentUserKey, fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false
  });

  useEffect(() => {
    if (process.env.NODE_ENV === 'production' && result.data) {
      analytics.setUser(result.data);
    }
  }, [result.data]);

  return result;
}

// Convenience accessor: orgCode is the only field most consumers need, and
// they only render after the critical-meta gate in App.jsx, so the data is
// guaranteed loaded.
export function useOrgCode() {
  return useCurrentUser().data?.orgCode;
}
